import React from 'react'
import { TabInitialState, TabStateReturn, useTabState } from 'reakit/Tab'

type TabsProps = {
  settings?: TabInitialState
}

const TabsContext = React.createContext<TabStateReturn | null>(null)
export const useTabsContext = () => React.useContext(TabsContext)

export function Tabs({ settings, children }: React.PropsWithChildren<TabsProps>) {
  const state = useTabState(settings)
  const value = React.useMemo(() => state, [state])

  return (
    <TabsContext.Provider value={value}>
      <div className="w-full space-y-1">{children}</div>
    </TabsContext.Provider>
  )
}
